import { useState } from "react";

const useSteps = (stepsComponents = [], initialStep) => {
  const [currentStep, setCurrentStep] = useState(initialStep || 0);

  const stepBack = () => {
    setCurrentStep((prev) => Math.max(0, prev - 1));
  };

  const nextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, stepsComponents.length - 1));
  };

  const skipNextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 2, stepsComponents.length - 1));
  };

  const goToStep = (step) => setCurrentStep(step);

  return {
    step: currentStep,
    ToRender: stepsComponents[currentStep],
    stepBack,
    nextStep,
    skipNextStep,
    stepsCount: stepsComponents.length,
    goToStep,
  };
};

export default useSteps;
